// 全站滚动渐显效果
document.addEventListener('DOMContentLoaded', function () {
  // 需要渐显的元素选择器
  const targets = document.querySelectorAll(
    '.card-wrapper, .banner, section, .hero, h1, h2, .product-card, img'
  );

  targets.forEach(el => el.classList.add('fade-in-element'));

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // 只触发一次
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(el => observer.observe(el));
});
